/* rc-carousel — arrow scrolling + end-state for scroll-snap carousels.
   Event-delegated + idempotent. Load once, defer. */
(function () {
  if (window.__rcCarouselInit) return;
  window.__rcCarouselInit = true;

  function update(root) {
    if (!root) return;
    var t = root.querySelector('[data-rc-carousel-track]');
    if (!t) return;
    var prev = root.querySelector('[data-rc-carousel-prev]');
    var next = root.querySelector('[data-rc-carousel-next]');
    var max = t.scrollWidth - t.clientWidth - 2;
    var overflowing = t.scrollWidth > t.clientWidth + 4;
    if (prev) prev.disabled = !overflowing || t.scrollLeft <= 2;
    if (next) next.disabled = !overflowing || t.scrollLeft >= max;
  }

  function step(t, dir) {
    var item = t.querySelector('.rc-carousel__item');
    var gap = 20;
    var amount = item ? item.getBoundingClientRect().width + gap : t.clientWidth * 0.8;
    t.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rc-carousel-prev],[data-rc-carousel-next]');
    if (!btn) return;
    var root = btn.closest('[data-rc-carousel]');
    var t = root && root.querySelector('[data-rc-carousel-track]');
    if (!t) return;
    step(t, btn.hasAttribute('data-rc-carousel-prev') ? -1 : 1);
  });

  // Throttle the arrow-state recompute to one layout read per frame (smooth scroll/drag).
  var rafScroll = false;
  document.addEventListener('scroll', function (e) {
    var t = e.target.closest && e.target.closest('[data-rc-carousel-track]');
    if (!t || rafScroll) return;
    rafScroll = true;
    requestAnimationFrame(function () {
      rafScroll = false;
      update(t.closest('[data-rc-carousel]'));
    });
  }, true);

  // Click-and-drag to scroll (mouse / pen). Touch keeps native momentum scroll.
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' || e.button !== 0) return;
    var t = e.target.closest('[data-rc-carousel-track]');
    if (!t) return;
    drag = { t: t, startX: e.clientX, startLeft: t.scrollLeft, moved: 0 };
    t.classList.add('is-dragging');
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.startX;
    if (Math.abs(dx) > drag.moved) drag.moved = Math.abs(dx);
    drag.t.scrollLeft = drag.startLeft - dx;
    e.preventDefault();
  }, { passive: false });
  function endDrag() {
    if (!drag) return;
    var t = drag.t, moved = drag.moved;
    t.classList.remove('is-dragging');
    // If the pointer actually moved, swallow the click so a card link doesn't fire.
    if (moved > 6) {
      var supp = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      t.addEventListener('click', supp, true);
      setTimeout(function () { t.removeEventListener('click', supp, true); }, 0);
    }
    update(t.closest('[data-rc-carousel]'));
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  function initAll() { document.querySelectorAll('[data-rc-carousel]').forEach(update); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', initAll);
})();
